import styled from 'styled-components';
import { colors } from '@alixpartners/ui-components';

export const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	height: 100%;
`;

export const SummaryWrapper = styled.div`
	background-color: white;
	padding: 32px;
`;

export const LoadingWrapper = styled.div`
	height: 100%;
	display: flex;
	flex-direction: column;
	justify-content: center;
`;

export const ScrollContainer = styled.div`
	height: 100%;
	overflow: auto;
`;

export const Section = styled.div`
	display: flex;
	flex-direction: column;
	padding: 32px 32px 0 32px;
	background: linear-gradient(
		180deg,
		${colors.greyBg},
		rgba(242, 242, 242, 0) 32px
	);

	&:first-child {
		background: none;
	}
`;

export const ChartWrapper = styled.div`
	display: flex;
	width: 100%;
`;

export const Title = styled.div`
	font-weight: 500;
	font-size: 23px;
	line-height: 31px;
	letter-spacing: 0.3px;
	color: black;
	padding-bottom: 20px;
	display: flex;
	justify-content: space-between;
	align-items: center;
`;

export const ArrowWrapper = styled.div`
	display: flex;
	align-items: center;
	padding-right: 16px;
	padding-bottom: 40px;
`;

export const ArrowRight = styled.div`
	width: 0;
	height: 0;
	border-top: 18px solid transparent;
	border-bottom: 18px solid transparent;
	border-left: 12px solid ${({ color }) => color || colors.chartBrightTeal};
	opacity: 0.2;
`;

export const MainChartWrapper = styled.div`
	overflow: hidden;
	width: 100%;
`;

export const SubHeaderWrapper = styled.div`
	display: flex;
	align-items: center;
	padding-bottom: 24px;
`;

export const SubTitleWrapper = styled.div`
	display: flex;
	width: 100%;
	align-items: center;
`;

export const Helper = styled.div`
	padding: 0 8px;
	font-size: 16px;
	color: ${colors.grey5};
`;
